import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiUrls, userAccountUrls } from '../../enum/routes';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { UrlBuilderService } from '../url-builder.service';
import { TwoFactorAuthSecretKey } from '../../models/accounting.model';

@Injectable({
  providedIn: 'root'
})
export class AccountingService {
  private http = inject(HttpClient);
  private urlBuilder = inject(UrlBuilderService);


  activate2FA(token: string): Observable<TwoFactorAuthSecretKey> {
    let url = this.urlBuilder.userAccountUrlBuild(userAccountUrls.activate2FA);
    return this.http.get<TwoFactorAuthSecretKey>(`${url}${token}/`).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error) => {
        return throwError(() => new Error(error));
      })
    );
  }

  verify2FA(token: string, totp: string) {
    let url = this.urlBuilder.userAccountUrlBuild(userAccountUrls.verify2FA);
    return this.http.post(`${url}${token}/`, { totp_code: totp }).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error) => {
        return throwError(() => new Error(error));
      })
    );
  }
}
